module.exports = __webpack_public_path__ + "img/landing_security.c6dbf417.png";